import React, { Component } from 'react';
import { store } from './Store/store';
import { fetchFeatureToggles } from './Store/Slices/ToggleSlice';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import './custom.css';
import './theme.css';
import AuthContext from './AuthContext';
import { Layout } from './Shared/Layout';

export default class App extends Component {
    static displayName = App.name;
    static contextType = AuthContext; // Enable context access

    componentDidMount() {
        const { isChecked, validate } = this.context;
        store.dispatch(fetchFeatureToggles());

        // Call validate only once to avoid infinite loops
        if (!isChecked && typeof validate === 'function') {
            validate();
        }
    }

    renderRoutes = (routes) => {
        return routes.map((route, index) => {
            const { children, ...rest } = route;

            if (children) {
                return (
                    <Route key={index} {...rest}>
                        {this.renderRoutes(children)}
                    </Route>
                );
            }

            return <Route key={index} {...rest} />;
        });
    };

    render() {
        return (
            <Layout>
                <Routes>
                    {this.renderRoutes(AppRoutes)}
                </Routes>
            </Layout>
        );
    }
}
